import { render, staticRenderFns } from "./text-field-declaracoes-arquivos.vue?vue&type=template&id=6e02c43f"
import script from "./text-field-declaracoes-arquivos.vue?vue&type=script&lang=js"
export * from "./text-field-declaracoes-arquivos.vue?vue&type=script&lang=js"
import style0 from "./text-field-declaracoes-arquivos.vue?vue&type=style&index=0&id=6e02c43f&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports